import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/ireland",
    name: "Ireland",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/Ireland.vue")
  },
  {
    path: "/japan",
    name: "Japan",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/Japan.vue")
  },
  {
    path: "/other",
    name: "Other",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/Other.vue")
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/contact",
    name: "Contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/Contact.vue")
  }
];

const router = new VueRouter({
  routes
});

export default router;
